module.exports = __webpack_public_path__ + "static/media/transforming-nuneaton.cef9fcaa.jpg";